import type * as React from "react";

import { cn } from "@/lib/utils";

interface SpinnerProps {
	/** Read by screen readers in place of the ring. */
	label: string;
	className?: string;
}

// A ring in the dashboard tokens. `className` is merged last, so a caller sets
// the size with `h-*`/`w-*` and the default 24px ring is replaced.
function Spinner({ label, className }: SpinnerProps): React.ReactElement {
	return (
		<div
			role="status"
			className={cn(
				"h-6 w-6 animate-spin rounded-full border-2 border-dashboard-border border-t-dashboard-accent",
				className,
			)}
		>
			<span className="sr-only">{label}</span>
		</div>
	);
}

export { Spinner };
